export default function AlertRuleService($http, appSettings) {
  'ngInject';
  this.createAlertRule = function (alertModel) {
    var endpoint = appSettings.InReachApiAlertRulesEndpoint;

    return $http.post(endpoint, alertModel);
  };

  this.getEquipmentByAlertRuleId = function (id) {
    return $http.get(appSettings.InReachApiAlertRulesEndpoint + '/' + id + '/equipment');
  };

  this.getRule = function (rule) {

    if (!rule) return;

    if (!rule.id) {
      rule = {
        id: rule
      };
    }

    return $http.get(appSettings.InReachApiAlertRulesEndpoint + "/" + rule.id);
  };

  this.updateRule = function (rule) {
    return $http.put(appSettings.InReachApiAlertRulesEndpoint + "/" + rule.id, rule);
  };

  this.deleteRule = function (ruleId) {
    return $http.delete(appSettings.InReachApiAlertRulesEndpoint + '/' + ruleId);
  };
}